import { Link } from "wouter";
import { Linkedin, MapPin, Phone, Mail } from "lucide-react";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const serviceLinks = [
        { name: "Commercial Combined Insurance", path: "/services#commercialcombined" },
        { name: "Residential Property Owners' Insurance", path: "/services#residentialpropertyowners" },
        { name: "Commercial Property Owners' Insurance", path: "/services#commercialpropertyowners" },
    ];

    const companyLinks = [
        { name: "About Us", path: "/about" },
        { name: "Contact", path: "/contact" },
    ];

    return (
        <footer className="bg-neutral-800 text-white">
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
                    <div>
                        <h3 className="text-xl font-heading font-semibold mb-4">Axent Brokers</h3>
                        <p className="text-neutral-200 mb-4">
                            Providing comprehensive insurance solutions for businesses since 2016.
                        </p>
                        <div className="flex space-x-4">
                            <a href="https://www.linkedin.com/company/axent-brokers-ltd" target="_blank" rel="noopener noreferrer">
                                <button className="text-neutral-200 hover:text-white transition-colors bg-transparent border-0 p-0 cursor-pointer">
                                    <Linkedin size={18} />
                                </button>
                            </a>
                        </div>
                    </div>

                    <div>
                        <h3 className="text-lg font-heading font-semibold mb-4">Insurance Services</h3>
                        {/*<ul className="space-y-2">*/}
                        {/*    {serviceLinks.map((link) => (*/}
                        {/*        <li key={link.path}>*/}
                        {/*            <Link href={link.path}>*/}
                        {/*                <span className="text-neutral-200 hover:text-white transition-colors cursor-pointer">*/}
                        {/*                    {link.name}*/}
                        {/*                </span>*/}
                        {/*            </Link>*/}
                        {/*        </li>*/}
                        {/*    ))}*/}
                        {/*</ul>*/}
                        <ul className="space-y-2">
                            {serviceLinks.map((link) => (
                                <li key={link.path}>
                                    {link.path.includes('#') ? (
                                        (() => {
                                            const [page, hash] = link.path.split('#');
                                            // For same-page navigation, use hash-only
                                            return (
                                                <a href={`${page}#${hash}`}>
                                                    <span className="text-neutral-200 hover:text-white transition-colors cursor-pointer">
                                                        {link.name}
                                                    </span>
                                                </a>
                                            );
                                        })()
                                    ) : (
                                        <Link href={link.path}>
                                            <span className="text-neutral-200 hover:text-white transition-colors cursor-pointer">
                                                {link.name}
                                            </span>
                                        </Link>
                                    )}
                                </li>
                            ))}
                        </ul>
           
                    </div>

                    <div>
                        <h3 className="text-lg font-heading font-semibold mb-4">Company</h3>
                        <ul className="space-y-2">
                            {companyLinks.map((link) => (
                                <li key={link.path}>
                                    <Link href={link.path}>
                                        <span className="text-neutral-200 hover:text-white transition-colors cursor-pointer">
                                            {link.name}
                                        </span>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                        <div className="flex py-2">
                            <a href="/assets/Axent Privacy Notice Policyholders.pdf" target="_blank" rel="noopener noreferrer">
                                <span className="text-neutral-200 hover:text-white transition-colors cursor-pointer">
                                    Privacy Notice - Policyholders
                                </span>
                            </a>
                        </div>
                        <div className="flex py-2">
                            <a href="/assets/Axent Privacy Notice Brokers.pdf" target="_blank" rel="noopener noreferrer">
                                <span className="text-neutral-200 hover:text-white transition-colors cursor-pointer">
                                    Privacy Notice - Brokers
                                </span>
                            </a>
                        </div>
                    </div>

                    <div>
                        <h3 className="text-lg font-heading font-semibold mb-4">Contact</h3>
                        <ul className="space-y-2">
                            {/*<li className="flex items-start">*/}
                            {/*    <MapPin className="mr-2 h-5 w-5 mt-0.5 flex-shrink-0" />*/}
                            {/*    <span>13 Wolverhampton Road<br />Codsall, Wolverhampton<br />WV8 1PT</span>*/}
                            {/*</li>*/}
                            <li className="flex items-center">
                                <Phone className="mr-2 h-5 w-5 flex-shrink-0" />
                                <span>01902 375559</span>
                            </li>
                            <li className="flex items-center">
                                <Mail className="mr-2 h-5 w-5 flex-shrink-0" />
                                <span>info@axentbrokers.com</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-neutral-700 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-neutral-200 text-sm mb-4 md:mb-0">
                            &copy; {currentYear} Axent Brokers. Axent Brokers Limited Registered in England Company Number 10430400. Registered Office 13 Wolverhampton Road, Codsall, Wolverhampton. WV8 1PT.
                            Axent Brokers Limited is an appointed representative of Blue Shield Insurance Services Limited (FRN: 303304) which is authorised and regulated by the Financial Conduct Authority("FCA").
                            Blue Shield Insurance Services Limited (No 01164376) is registered in England and Wales. Registered office: Blue Shield House, Prospect Road, Hythe, Kent CT21 5NS
                        </p>
                        <div className="flex space-x-6" hidden>
                            <Link href="/privacy">
                                <span className="text-neutral-200 hover:text-white text-sm transition-colors cursor-pointer">
                                    Policyholders' Privacy Policy
                                </span>
                            </Link>
                            <Link href="/privacy">
                                <span className="text-neutral-200 hover:text-white text-sm transition-colors cursor-pointer">
                                    Brokers' Privacy Policy
                                </span>
                            </Link>
                            <Link href="/terms">
                                <span className="text-neutral-200 hover:text-white text-sm transition-colors cursor-pointer">
                                    Terms of Service
                                </span>
                            </Link>
                            <Link href="/sitemap">
                                <span className="text-neutral-200 hover:text-white text-sm transition-colors cursor-pointer">
                                    Sitemap
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
